/** ******** 学术管理  ********* */
// 获取学术项目列表
export const getAcademicList = {
  url: '/admin/science/list.json',
  method: 'get'
};

// 获取团队树形列表
export const getSupplierTreeInfo = {
  url: '/admin/supplierGroup/getStructureTreeInfo.json',
  method: 'get'
};

// 获取关联商品列表
export const getMerchandise = {
  url: '/admin/merchandise/getMerchandise',
  method: 'get'
};

// 新增学术项目
export const updateAcademic = {
  url: '/admin/science/edit.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 学术项目详情查询
export const getAcademicProjectDetail = {
  url: '/admin/science/detail.json',
  method: 'get'
};

// 删除学术项目
export const delAcademic = {
  url: '/admin/science/delete.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 发布学术项目
export const publishAcademic = {
  url: '/admin/science/publish.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};
// 结束学术项目
export const finishAcademic = {
  url: '/admin/science/finish.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 参会名单列表
export const getJoinNameList = {
  url: '/admin/scienceAttendor/list.json',
  method: 'get'
};

// 导出参会名单
export const exportJoinNameList = {
  url: '/admin/scienceAttendor/excel.json'
};
